<template>
  <div class="footer">
    <div class="DIV">
      <img class="footer-logo" src="~@img/stk-logo-white.png" alt="Logo">
      <div>
        <a class="name">BEIJING CY-TECH BIOTECH CO.LTD</a>
        <br>
        <a>北京赛泰克生物科技有限公司</a>
      </div>
    </div>
    <div class="footer-center-box">
      <div>{{this.stkAboutusInfo.aboutusName}}</div>
      <div>电话：{{this.stkAboutusInfo.phoneNumberName}} 传真：{{this.stkAboutusInfo.faxName}}</div>
    </div>
    <div class="footer-bottom-box">COPYRIGHT ©️ 北京赛泰克生物科技有限公司 2007-2018, 版权所有 京ICP备14006254号-1</div>
  </div>
</template>

<script>
import { post, get } from "@/axios/index";
export default {
  data() {
    return {
      stkAboutusInfo: {
        //地址
        aboutusId: "",
        aboutusName: "",
        //电话
        phoneNumberId: "",
        phoneNumberName: "",
        //传真
        faxId: "",
        faxName: ""
      }
    };
  },
  methods: {
    gatListByStatus() {
      get("/stkaboutus/gatListByStatus", {}).then(
        ren => {
          console.log("150=======", ren.data.result);
          let res = ren.data.result;
          for (let i in res) {
            console.log("108=======", res[i]);
            if (res[i].contact === "地址") {
              this.stkAboutusInfo.aboutusId = res[i].id;
              this.stkAboutusInfo.aboutusName = res[i].name;
            }
            if (res[i].contact === "电话") {
              this.stkAboutusInfo.phoneNumberId = res[i].id;
              this.stkAboutusInfo.phoneNumberName = res[i].name;
            }
            if (res[i].contact === "传真") {
              this.stkAboutusInfo.faxId = res[i].id;
              this.stkAboutusInfo.faxName = res[i].name;
            }
          }
          console.log("166=======", this.stkAboutusInfo);
        },
        err => {
          console.log(err);
          this.$message({
            type: "error",
            message: "error"
          });
        }
      );
    }
  },
  mounted() {
    //获取详情
    this.gatListByStatus();
  }
};
</script>

<style lane="less" scoped>
.footer-logo {
  width: 90px;
}
.DIV {
  display: flex;
  justify-content: center;
  align-items: center;
}
.name {
  position: relative;
  left: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue